const validateTaxId = (id: string): boolean => {
  // three letters that correspond to the first three consonants in the family name
  // three letters that correspond to the first, third, and fourth consonants in the first name
  // two digits that correspond to the last digits of the birth year
  // one letter that corresponds to the letter for the month of birth—letters are used in alphabetical order, but only the letters A to E, H, L, M, P, R to T are used (so, January is A and October is R)
  // two digits that correspond to the day of the month of birth in order to differentiate between genders, 40 is added to the day of birth for women
  // four digits that correspond to the area code specific to the municipality where the person was born (country/region-wide codes are used for foreign countries/regions)
  // one parity digit

  // http://blog.marketto.it/2016/01/regex-validazione-codice-fiscale-con-omocodia/

  const TAX_ID_REGEX =
    /^(?:[A-Z][AEIOU][AEIOUX]|[AEIOU]X{2}|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i

  if (!id || id.length === 0) {
    return false
  }
  return TAX_ID_REGEX.test(id)
}

export default validateTaxId
